import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../../core/services/layout.service';

@Component({
  selector: 'brn-mobile-header[title]',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnInit {
  @Input()
  title!: string;

  @Input()
  links?: {
    title: string;
    path: string;
  }[];

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {}

  toggleMobileMenu(): void {
    console.log('toggleMobileMenu');
    
    this.layoutService.toggleMobileMenu();
  }
}
